// @ts-nocheck
/* eslint-disable */

exports.controls = void 0;

var _colors = require('./colors.theme');

var controls = {
  button: {
    mainColor: {
      withLightBg: _colors.colors.primaryBrand4,
      withDarkBg: _colors.colors.primaryBrand4
    },
    textColor: {
      withLightBg: _colors.colors.primaryBrand4,
      withDarkBg: _colors.colors.primaryBrand4
    },
    border: {
      radius: '8px'
    },
    padding: '.7em 2em',
    minWidth: '80px',
    fontSize: '1rem'
  },
  card: {
    padding: '1rem',
    border: {
      width: '1px',
      style: 'solid',
      color: _colors.colors.secondaryBrand1,
      radius: '5px'
    },
    background: {
      color: _colors.colors.white
    },
    boxShadow: '0 0 4px rgba(215, 214, 203, 0.5)'
  },
  listItem: {
    textColor: {
      withLightBg: _colors.colors.primaryFont,
      withDarkBg: _colors.colors.white
    },
    hoverBackgroundColor: {
      withLightBg: _colors.colors.secondaryBrand3,
      withDarkBg: _colors.colors.primaryBrand2
    },
    selectedBackgroundColor: {
      withLightBg: _colors.colors.secondaryBrand3,
      withDarkBg: _colors.colors.primaryBrand2
    },
    padding: '.7em 0'
  },
  list: {
    background: {
      color: {
        withLightBg: _colors.colors.white,
        withDarkBg: _colors.colors.primaryBrand1
      }
    },
    border: {
      radius: '10px',
      width: '1px',
      style: 'solid',
      color: {
        withLightBg: _colors.colors.secondaryBrand1,
        withDarkBg: _colors.colors.primaryBrand2
      }
    }
  },
  select: {
    background: {
      color: {
        withLightBg: 'transparent',
        withDarkBg: 'transparent'
      }
    },
    border: {
      radius: '10px',
      width: '1px',
      style: 'solid',
      color: {
        withLightBg: _colors.colors.primaryBrand1,
        withDarkBg: _colors.colors.white
      },
      hoverColor: {
        withLightBg: _colors.colors.primaryBrand4,
        withDarkBg: _colors.colors.primaryBrand4
      },
      focusColor: {
        withLightBg: _colors.colors.primaryBrand4,
        withDarkBg: _colors.colors.primaryBrand4
      }
    },
    padding: '.7em 1em'
  }
};
exports.controls = controls;
